import { ParseService } from '../parse/parse.service';
import { QueryInterface } from '../parse/query-interface';
import { FormGroup } from '@angular/forms';
import { Injectable } from '@angular/core';
import { DateServiceService } from './dateservice';
import { ToastrService } from 'ngx-toastr';
import { HardCodedValues } from '../hard-coded-values';
import { StorageConfiguration } from '../storage-setting/storage-configuration';

export class UserClass {
    personalInfo: Object;
    department: Object;
    resignationInfo: Object;
    location: Object;
    designation: Object;
    role: Object;
    officialInfo: Object;
    organisation: Object;
    systemInfo: Object;
    locationInfo: Object;
    designationInfo: Object;
    departmentInfo: Object;
    organisationInfo: Object;
    roleInfo: Object;
    reportingTo: Object;
    experienceInfo: [];
    locationHistory: [];
    firstName: String;
    lastName: String;
    email: String;
}

@Injectable({
    providedIn: 'root'
})

export class GetSetOperations {

    profileForm: FormGroup;
    user = new UserClass();
    locationName: any;
    departmentName: any;
    designationName: any;
    OrganisationName: any;
    roleId
    existingRoleId: any;
    userId: any;
    tenantId = '';

    constructor(
        private parseService: ParseService,
        private queryInterface: QueryInterface,
        private _dateservice: DateServiceService,
        private toastr: ToastrService,
        private hardCodedValues: HardCodedValues,
        private storageConfiguration: StorageConfiguration
    ) {
        this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    }

    getProfile(results) {
        this.user.personalInfo = results.get('personalInfo')
        this.user.department = results.get('department')
        this.user.resignationInfo = results.get('resignationInfo')
        this.user.location = results.get('location')
        this.user.designation = results.get('designation')
        this.user.reportingTo = results.get('reportingTo')
        this.user.firstName = results.get('firstName')
        this.user.lastName = results.get('lastName')
        this.user.email = results.get('email')
        this.user.role = results.get('role')
        this.user.officialInfo = results.get('officialInfo')
        this.user.organisation = results.get('organisation')
        this.user.systemInfo = results.get('systemInfo')
        this.user.locationInfo = results.get('locationInfo')
        this.user.organisationInfo = results.get('organisationInfo')
        this.user.departmentInfo = results.get('departmentInfo')
        this.user.designationInfo = results.get('designationInfo')
        this.user.roleInfo = results.get('roleInfo')

        return this.user;
    }

    createprojects(projectValue): any {
        let projectClass = this.parseService.instance.Object.extend('Project');
        var projectDetails = new projectClass();

        projectDetails.set('assignedResources', projectValue.assignedResources);
        projectDetails.save({
            success: function (_profile) {
                this.toastr.success('Project Created Successfully');
            },
            error: function (error) {
            }
        });
    }

    updatePersonal(objectId, profileValues, firstName, lastName): any {
        this.queryInterface.executeQuery(this.parseService, 'Profile', [
            { condition: 'equalTo', field: 'objectId', value: objectId }]).then(result => {
                var results = result[0];
                results.set('firstName', firstName)
                results.set('lastName', lastName)
                results.set('personalInfo', profileValues.personalInfo);
                results.save({
                    success: function (_profile) {
                        this.toastr.success(this.toastMessage.Personal + ' ' + this.toastMessage.Save);
                    },
                    error: function (error) {

                    }
                });
            });
    }

    updateProfile(objectId, data, profileValues, locationList, organisationList, departmentList, roleList, reportingtoLists) {
        this.userId = objectId
        let isLoctionChanged = false;
        let isOrganisationChanged = false;
        let isDepartmentChanged = false;
        // let isDesignationChanged = false;
        let isRoleChanged = false;
        let isReportingChanged = false;

        this.queryInterface.executeQuery(this.parseService, 'Profile', [{ condition: 'equalTo', field: 'objectId', value: objectId }, { condition: 'equalTo', field: 'tenantId', value: this.tenantId }])
            .then(results => {
                var result = results[0];
                result.set('officialInfo', data.officialInfo);
                result.set('workMode', profileValues.workMode);
                result.set('timeZone', profileValues.timeZone);
                // Location Check
                var currentLocation = result.get('location');
                if (
                    currentLocation.id != profileValues.locationId
                ) {
                    var location = new this.parseService.instance.Object('Location');
                    location.id = profileValues.locationId;
                    result.set('location', location);
                    var locationHistory = result.get('locationHistory');
                    if (locationHistory.length == 0) {
                        var currentlocation = locationList.filter(
                            location => location.id == profileValues.locationId
                        );
                        let locationHistoryInfo = {
                            id: profileValues.locationId,
                            name: currentlocation[0].name,
                            startDate: new Date(),
                            endDate: '',
                            isActive: true
                        };
                        locationHistory.push(locationHistoryInfo);
                        result.set('locationHistory', locationHistory);
                    } else {
                        locationHistory.forEach(element => {
                            if (element.isActive) {
                                isLoctionChanged = true;
                                element.isActive = false;
                                element.endDate = new Date();
                            }
                        });
                    }
                }
                if (isLoctionChanged) {
                    var currentlocation = locationList.filter(
                        location => location.id == profileValues.locationId
                    );
                    let locationHistoryInfo = {
                        id: profileValues.locationId,
                        name: currentlocation[0].name,
                        startDate: new Date(),
                        endDate: '',
                        isActive: true
                    };
                    locationHistory.push(locationHistoryInfo);
                    result.set('locationHistory', locationHistory);
                }

                // Organisation Check
                var currentOrganisation = result.get('organisation');
                if (
                    currentOrganisation.id != profileValues.organisationId
                ) {
                    var organisation = new this.parseService.instance.Object('Organisation');
                    organisation.id = profileValues.organisationId;
                    result.set('organisation', organisation);
                    var organisationHistory = result.get('organisationHistory');
                    if (organisationHistory == undefined || organisationHistory.length == 0) {
                        var currentOrganisation = organisationList.filter(
                            organisation => organisation.id == profileValues.organisationId
                        );
                        let organisationHistoryInfo = {
                            id: profileValues.organisationId,
                            name: currentOrganisation[0].name,
                            startDate: new Date(),
                            endDate: '',
                            isActive: true
                        };
                        organisationHistory.push(organisationHistoryInfo);
                        result.set('organisationHistory', organisationHistory);
                    } else {
                        organisationHistory.forEach(element => {
                            if (element.isActive) {
                                isOrganisationChanged = true;
                                element.isActive = false;
                                element.endDate = new Date();
                            }
                        });
                    }
                }
                if (isOrganisationChanged) {
                    var currentOrganisation = organisationList.filter(
                        organisation => organisation.id == profileValues.organisationId
                    );
                    let organisationHistoryInfo = {
                        id: profileValues.organisationId,
                        name: currentOrganisation[0].name,
                        startDate: new Date(),
                        endDate: '',
                        isActive: true
                    };
                    organisationHistory.push(organisationHistoryInfo);
                    result.set('organisationHistory', organisationHistory);
                }

                // Department Check
                var currentDepartment = result.get('department');
                if (
                    currentDepartment.id != profileValues.departmentId
                ) {
                    var department = new this.parseService.instance.Object('Department');
                    department.id = profileValues.departmentId;
                    result.set('department', department);
                    var departmentHistory = result.get('departmentHistory');
                    if (departmentHistory.length == 0) {
                        var currentDepartment = departmentList.filter(
                            department => department.id == profileValues.departmentId
                        );
                        let departmentHistoryInfo = {
                            id: profileValues.departmentId,
                            name: currentDepartment[0].name,
                            startDate: new Date(),
                            endDate: '',
                            isActive: true
                        };
                        departmentHistory.push(departmentHistoryInfo);
                        result.set('departmentHistory', departmentHistory);
                    } else {
                        departmentHistory.forEach(element => {
                            if (element.isActive) {
                                isDepartmentChanged = true;
                                element.isActive = false;
                                element.endDate = new Date();
                            }
                        });
                    }
                }
                if (isDepartmentChanged) {
                    var currentDepartment = departmentList.filter(
                        department => department.id == profileValues.departmentId
                    );
                    let departmentHistoryInfo = {
                        id: profileValues.departmentId,
                        name: currentDepartment[0].name,
                        startDate: new Date(),
                        endDate: '',
                        isActive: true
                    };
                    departmentHistory.push(departmentHistoryInfo);
                    result.set('departmentHistory', departmentHistory);
                }

                var currentRole = result.get('role');
                this.existingRoleId = currentRole.id;
                if (
                    currentRole.id != profileValues.roleId
                ) {
                    var role = new this.parseService.instance.Object('_Role');
                    role.id = profileValues.roleId;
                    result.set('role', role);
                    var roleHistory = result.get('roleHistory');
                    if (roleHistory.length == 0) {
                        var currentRole = roleList.filter(
                            role => role.id == profileValues.roleId
                        );
                        let roleHistoryInfo = {
                            id: profileValues.roleId,
                            name: currentRole[0].name,
                            startDate: new Date(),
                            endDate: '',
                            isActive: true
                        };
                        roleHistory.push(roleHistoryInfo);
                        result.set('roleHistory', roleHistory);
                    } else {
                        roleHistory.forEach(element => {
                            if (element.isActive) {
                                isRoleChanged = true;
                                element.isActive = false;
                                element.endDate = new Date();
                            }
                        });
                    }
                }
                if (isRoleChanged) {
                    var currentRole = roleList.filter(
                        role => role.id == profileValues.roleId
                    );
                    let roleHistoryInfo = {
                        id: profileValues.roleId,
                        name: currentRole[0].name,
                        startDate: new Date(),
                        endDate: '',
                        isActive: true
                    };
                    roleHistory.push(roleHistoryInfo);
                    result.set('roleHistory', roleHistory);
                }
                if (this.existingRoleId !== profileValues.roleId) {
                    this.roleId = profileValues.roleId
                    this.getProfileToUser();
                }


                var currentReporting = result.get('reportingTo');
                if (
                    currentReporting.id != profileValues.reporterId
                ) {
                    var reportingTo = new this.parseService.instance.Object('Profile');
                    reportingTo.id = profileValues.reporterId;
                    result.set('reportingTo', reportingTo);
                    var reporterHistory = result.get('reporterHistory');
                    if (reporterHistory.length == 0) {
                        var currentReporting = reportingtoLists.filter(
                            reportingTo => reportingTo.id == profileValues.reporterId
                        );
                        let reportHistoryInfo = {
                            id: profileValues.reporterId,
                            name: currentReporting[0].name,
                            startDate: new Date(),
                            endDate: '',
                            isActive: true
                        };
                        reporterHistory.push(reportHistoryInfo);
                        result.set('reporterHistory', reporterHistory);
                    } else {
                        reporterHistory.forEach(element => {
                            if (element.isActive) {
                                isReportingChanged = true;
                                element.isActive = false;
                                element.endDate = new Date();
                            }
                        });
                    }

                }
                if (isReportingChanged) {
                    var currentReporting = reportingtoLists.filter(
                        reportingTo => reportingTo.id == profileValues.reporterId
                    );
                    let reportHistoryInfo = {
                        id: profileValues.reporterId,
                        name: currentReporting[0].name,
                        startDate: new Date(),
                        endDate: '',
                        isActive: true
                    };
                    reporterHistory.push(reportHistoryInfo);
                    result.set('reporterHistory', reporterHistory);

                }
                result.save({
                    success: function (_user) {
                    },
                    error: function (error) {
                    }
                });
            });
    }

    setScreenShot(objectId, value): Promise<any> {
        return new Promise((resolve, reject) => {
            this.queryInterface.executeQuery(this.parseService, 'Profile', [{ condition: 'equalTo', field: 'objectId', value: objectId }])
                .then(results => {
                    var result = results[0];
                    result.set('screenShot', value);
                    result.save().then(res => {
                        resolve(res);
                    });
                    if (value) {
                        this.toastr.info('Screenshot Enabled to this employee', '', {
                            timeOut: 2000
                        });
                    } else {
                        this.toastr.info('Screenshot Disabled to this employee', '', {
                            timeOut: 2000
                        });
                    }
                });
        });
    }

    meetingSave(objectId, value): Promise<any> {
        return new Promise((resolve, reject) => {

            this.queryInterface.executeQuery(this.parseService, 'Profile', [{ condition: 'equalTo', field: 'objectId', value: objectId }])
                .then(results => {
                    var result = results[0];
                    result.set('isMeeting', value);
                    result.save().then(res => {
                        resolve(res);
                    });
                    if (value) {
                        this.toastr.info('Meeting mode Enabled. Request the employee to re-login the Big Boss', '', {
                            timeOut: 5000
                        });
                    } else {
                        this.toastr.info('Meeting mode Disabled. Request the employee to re-login the Big Boss', '', {
                            timeOut: 5000
                        });
                    }
                });
        });
    }

    keyloggerSave(objectId, value) {
        this.queryInterface.executeQuery(this.parseService, 'Profile', [{ condition: 'equalTo', field: 'objectId', value: objectId }])
            .then(results => {
                var result = results[0];
                result.set('keylogger', value);
                result.save();
                if (value) {
                    this.toastr.info('Keylogger mode Enabled. Request the employee to re-login the Big Boss', '', {
                        timeOut: 5000
                    });
                } else {
                    this.toastr.info('Keylogger mode Disabled. Request the employee to re-login the Big Boss', '', {
                        timeOut: 5000
                    });
                }
            });
    }

    saveNotificationDetails(objectId, value, fieldName): Promise<any> {
        return new Promise((resolve, reject) => {
            this.queryInterface.executeQuery(this.parseService, 'Profile', [{ condition: 'equalTo', field: 'objectId', value: objectId }])
                .then(results => {
                    var result = results[0];
                    result.set(fieldName, value);
                    result.save().then(res => {
                        resolve(res);
                    });
                    let prop = this.hardCodedValues.getValues(fieldName);
                    if (value) {
                        this.toastr.info(prop + ' Notification Enabled to this employee', '', {
                            timeOut: 2000
                        });
                    } else {
                        this.toastr.info(prop + ' Notification Disabled to this employee', '', {
                            timeOut: 2000
                        });
                    }
                });
        });
    }

    updateProfileDetails(objectId, data, profileValues, locationList, organisationList, departmentList, roleList, reportingtoLists, esslData): Promise<any> {
        return new Promise((resolve, reject) => {
            this.userId = objectId
            let isLoctionChanged = false;
            let isOrganisationChanged = false;
            let isDepartmentChanged = false;
            let isRoleChanged = false;
            let isReportingChanged = false;

            this.queryInterface.executeQuery(this.parseService, 'Profile', [{ condition: 'equalTo', field: 'objectId', value: objectId }])
                .then(results => {
                    var result = results[0];
                    result.set('officialInfo', data.officialInfo);
                    result.set('esslEmployeeId', esslData.employeeId)
                    result.set('esslEmployeeCode', esslData.employeeCode)

                    // Location Check
                    var currentLocation = result.get('location');
                    if (
                        currentLocation.id != profileValues.locationId
                    ) {
                        var location = new this.parseService.instance.Object('Location');
                        location.id = profileValues.locationId;
                        result.set('location', location);
                        var locationHistory = result.get('locationHistory');
                        if (locationHistory.length == 0) {

                            var currentlocation = locationList.filter(
                                location => location.id == profileValues.locationId
                            );
                            let locationHistoryInfo = {
                                id: profileValues.locationId,
                                name: currentlocation[0].name,
                                startDate: new Date(),
                                endDate: '',
                                isActive: true
                            };
                            locationHistory.push(locationHistoryInfo);
                            result.set('locationHistory', locationHistory);
                        } else {
                            locationHistory.forEach(element => {
                                if (element.isActive) {
                                    isLoctionChanged = true;
                                    element.isActive = false;
                                    element.endDate = new Date();
                                }
                            });
                        }
                    }
                    if (isLoctionChanged) {
                        var currentlocation = locationList.filter(
                            location => location.id == profileValues.locationId
                        );
                        let locationHistoryInfo = {
                            id: profileValues.locationId,
                            name: currentlocation[0].name,
                            startDate: new Date(),
                            endDate: '',
                            isActive: true
                        };
                        locationHistory.push(locationHistoryInfo);
                        result.set('locationHistory', locationHistory);
                    }

                    // Organisation Check
                    var currentOrganisation = result.get('organisation');
                    if (
                        currentOrganisation.id != profileValues.organisationId
                    ) {
                        var organisation = new this.parseService.instance.Object('Organisation');
                        organisation.id = profileValues.organisationId;
                        result.set('organisation', organisation);
                        var organisationHistory = result.get('organisationHistory');
                        if (organisationHistory == undefined || organisationHistory.length == 0) {
                            var currentOrganisation = organisationList.filter(
                                organisation => organisation.id == profileValues.organisationId
                            );
                            let organisationHistoryInfo = {
                                id: profileValues.organisationId,
                                name: currentOrganisation[0].name,
                                startDate: new Date(),
                                endDate: '',
                                isActive: true
                            };
                            organisationHistory.push(organisationHistoryInfo);
                            result.set('organisationHistory', organisationHistory);
                        } else {
                            organisationHistory.forEach(element => {
                                if (element.isActive) {
                                    isOrganisationChanged = true;
                                    element.isActive = false;
                                    element.endDate = new Date();
                                }
                            });
                        }
                    }
                    if (isOrganisationChanged) {
                        var currentOrganisation = organisationList.filter(
                            organisation => organisation.id == profileValues.organisationId
                        );
                        let organisationHistoryInfo = {
                            id: profileValues.organisationId,
                            name: currentOrganisation[0].name,
                            startDate: new Date(),
                            endDate: '',
                            isActive: true
                        };
                        organisationHistory.push(organisationHistoryInfo);
                        result.set('organisationHistory', organisationHistory);
                    }

                    // Department Check
                    var currentDepartment = result.get('department');
                    if (
                        currentDepartment.id != profileValues.departmentId
                    ) {
                        var department = new this.parseService.instance.Object('Department');
                        department.id = profileValues.departmentId;
                        result.set('department', department);
                        var departmentHistory = result.get('departmentHistory');
                        if (departmentHistory.length == 0) {
                            var currentDepartment = departmentList.filter(
                                department => department.id == profileValues.departmentId
                            );
                            let departmentHistoryInfo = {
                                id: profileValues.departmentId,
                                name: currentDepartment[0].name,
                                startDate: new Date(),
                                endDate: '',
                                isActive: true
                            };
                            departmentHistory.push(departmentHistoryInfo);
                            result.set('departmentHistory', departmentHistory);
                        } else {
                            departmentHistory.forEach(element => {
                                if (element.isActive) {
                                    isDepartmentChanged = true;
                                    element.isActive = false;
                                    element.endDate = new Date();
                                }
                            });
                        }
                    }
                    if (isDepartmentChanged) {
                        var currentDepartment = departmentList.filter(
                            department => department.id == profileValues.departmentId
                        );
                        let departmentHistoryInfo = {
                            id: profileValues.departmentId,
                            name: currentDepartment[0].name,
                            startDate: new Date(),
                            endDate: '',
                            isActive: true
                        };
                        departmentHistory.push(departmentHistoryInfo);
                        result.set('departmentHistory', departmentHistory);
                    }

                    var currentRole = result.get('role');
                    this.existingRoleId = currentRole.id;
                    if (
                        currentRole.id != profileValues.roleId
                    ) {
                        var role = new this.parseService.instance.Object('_Role');
                        role.id = profileValues.roleId;
                        result.set('role', role);
                        var roleHistory = result.get('roleHistory');
                        if (roleHistory.length == 0) {
                            var currentRole = roleList.filter(
                                role => role.id == profileValues.roleId
                            );
                            let roleHistoryInfo = {
                                id: profileValues.roleId,
                                name: currentRole[0].name,
                                startDate: new Date(),
                                endDate: '',
                                isActive: true
                            };
                            roleHistory.push(roleHistoryInfo);
                            result.set('roleHistory', roleHistory);
                        } else {
                            roleHistory.forEach(element => {
                                if (element.isActive) {
                                    isRoleChanged = true;
                                    element.isActive = false;
                                    element.endDate = new Date();
                                }
                            });
                        }
                    }
                    if (isRoleChanged) {
                        var currentRole = roleList.filter(
                            role => role.id == profileValues.roleId
                        );
                        let roleHistoryInfo = {
                            id: profileValues.roleId,
                            name: currentRole[0].name,
                            startDate: new Date(),
                            endDate: '',
                            isActive: true
                        };
                        roleHistory.push(roleHistoryInfo);
                        result.set('roleHistory', roleHistory);
                    }
                    if (this.existingRoleId !== profileValues.roleId) {
                        this.roleId = profileValues.roleId

                        this.getProfileToUser();
                    }

                    var currentReporting = result.get('reportingTo');
                    if (
                        currentReporting.id != profileValues.reporterId
                    ) {
                        var reportingTo = new this.parseService.instance.Object('Profile');
                        reportingTo.id = profileValues.reporterId;
                        result.set('reportingTo', reportingTo);
                        var reporterHistory = result.get('reporterHistory');
                        if (reporterHistory.length == 0) {
                            var currentReporting = reportingtoLists.filter(
                                reportingTo => reportingTo.id == profileValues.reporterId
                            );
                            let reportHistoryInfo = {
                                id: profileValues.reporterId,
                                name: currentReporting[0].name,
                                startDate: new Date(),
                                endDate: '',
                                isActive: true
                            };
                            reporterHistory.push(reportHistoryInfo);
                            result.set('reporterHistory', reporterHistory);
                        } else {
                            reporterHistory.forEach(element => {
                                if (element.isActive) {
                                    isReportingChanged = true;
                                    element.isActive = false;
                                    element.endDate = new Date();
                                }
                            });
                        }

                    }
                    if (isReportingChanged) {
                        var currentReporting = reportingtoLists.filter(
                            reportingTo => reportingTo.id == profileValues.reporterId
                        );
                        let reportHistoryInfo = {
                            id: profileValues.reporterId,
                            name: currentReporting[0].name,
                            startDate: new Date(),
                            endDate: '',
                            isActive: true
                        };
                        reporterHistory.push(reportHistoryInfo);
                        result.set('reporterHistory', reporterHistory);
                    }
                    result.save().then(res => {
                        resolve(res);
                    })
                });
        });
    }

    getProfileToUser() {
        this.queryInterface.executeQuery(this.parseService, 'User', [
            {
                condition: 'equalTo', field: 'profile',
                value: {
                    __type: 'Pointer',
                    className: 'Profile',
                    objectId: this.userId
                }
            },
            { condition: 'include', value: 'profile' }]).then(results => {
                let result = results[0]
                this.userId = result.id
                var user = new this.parseService.instance.Object('_User');
                user.id = result.id
                this.removeRoleRelation(user)
                this.addRoleRelation(user)
            });
    }

    addRoleRelation(user) {
        var queryRel = new this.parseService.instance.Query('_Role');
        queryRel.equalTo('objectId', this.roleId);
        queryRel.first().then(function (role) {
            var relation = role.relation('users');
            relation.add(user);
            role.save().then((result) => {
            }, function (error) {
            });
            return role;
        });
    }

    removeRoleRelation(user) {
        var queryRel = new this.parseService.instance.Query('_Role');
        queryRel.equalTo('objectId', this.existingRoleId);
        queryRel.first().then(function (role) {
            var relation = role.relation('users');
            relation.remove(user);
            role.save().then((result) => {
            }, function (error) {
            });
            return role;
        });
    }

    updateExperience(objectId, experienceValues): Promise<any> {
        return new Promise((resolve, reject) => {
            this.queryInterface.executeQuery(this.parseService, 'Profile', [
                { condition: 'equalTo', field: 'objectId', value: objectId }]).then(result => {
                    var results = result[0];
                    results.set('experienceInfo', experienceValues);
                    results.save().then(rest => {
                        resolve(rest[0]);
                    }, reject);
                });
        });
    }

    updateProfessional(objectId, profileValues): Promise<any> {
        return new Promise((resolve, reject) => {

            this.queryInterface.executeQuery(this.parseService, 'Profile', [
                { condition: 'equalTo', field: 'objectId', value: objectId }]).then(result => {
                    var results = result[0];
                    results.set('resignationInfo', profileValues.resignationInfo);
                    results.set('systemInfo', profileValues.systemInfo);
                    results.save().then(res => {
                        resolve(res);
                    });
                });
        });

    }

}


